export default __webpack_public_path__ + "static/media/Car.693ec49a.svg";